// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"brightness"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4.57537 8.92462L1.5 12L4.57537 15.0754V19.4246H8.92462L12 22.5L15.0754 19.4246H19.4246V15.0754L22.5 12L19.4246 8.92462V4.57538H15.0754L12 1.5L8.92462 4.57538H4.57537V8.92462Z"}},{"tag":"circle","attrs":{"id":"fill2","cx":12,"cy":12,"r":5,"fill":"props.fillColor2"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.57537 8.92462L1.5 12L4.57537 15.0754V19.4246H8.92462L12 22.5L15.0754 19.4246H19.4246V15.0754L22.5 12L19.4246 8.92462V4.57538H15.0754L12 1.5L8.92462 4.57538H4.57537V8.92462Z","strokeWidth":"props.strokeWidth"}},{"tag":"circle","attrs":{"id":"stroke2","cx":12,"cy":12,"r":5,"stroke":"props.strokeColor2","strokeWidth":"props.strokeWidth"}}]}]};

const BrightnessIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'brightness',
    ref,
    icon: element,
  },
));

BrightnessIcon.displayName = 'BrightnessIcon';

export default BrightnessIcon;
